import { render, staticRenderFns } from "./TasksBoard.vue?vue&type=template&id=7e7f95d5&scoped=true&"
import script from "./TasksBoard.vue?vue&type=script&setup=true&lang=js&"
export * from "./TasksBoard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7f95d5",
  null
  
)

export default component.exports